import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {VehicleService} from 'services/calculator-items/vehicle.service';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-motorcycle',
    templateUrl: './motorcycle.component.html',
    styleUrls: ['./motorcycle.component.css']
})
export class MotorcycleComponent implements OnInit, OnDestroy {

    private nextSub: Subscription;

    public motoMileage = 25000;
    public errors: any = {};

    constructor(private emissionService: EmissionService,
                private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            if (this.motoMileage) {
                this.next();
            } else {
                this.errors.motoMileage = true;
            }
        });
    }

    ngOnInit() {
    }

    private next() {
        let params = {
            VEHICLETYPE: 'motorcycle',
            MILE: this.motoMileage
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.vehicleService.addToVehicleList({
                    title: this.getTitleForVehicleList(),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.router.navigate(['/individual/vehicle/list']);
                this.spinner.hide();
            }
        );
    }

    private getTitleForVehicleList() {
        return `Motorcyle, ${this.motoMileage.toLocaleString()} mi/yr`;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/motorcycle/motorcycle.component.ts